import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-FormProductoReactivo',
  templateUrl: './FormProductoReactivo.component.html',
  styleUrls: ['./FormProductoReactivo.component.css']
})
export class FormProductoReactivoComponent implements OnInit {

  /*
  miFormulario: FormGroup = new FormGroup({
    'producto': new FormControl('Catastro'),
    'precio': new FormControl(1530.00),
    'existencia': new FormControl(23)
  })
  */
  

  constructor(
    private fb: FormBuilder
  ) { }

  miFormulario: FormGroup = this.fb.group({
    
    producto: [ , [ Validators.required, Validators.minLength(3) ], ],
    precio: [ , [ Validators.required, Validators.min(0)], ],
    existencia: [ , [ Validators.required, Validators.min(0)], ]
    
  })

  ngOnInit() {
    //cargando valores iniciales al formulario
    this.miFormulario.reset({
      producto: "Sistema de Catastro",
      precio: 85000,
      existencia: 25
    })
  }

  //funcion de validación de Campos del Formulario
  campoEsValido( campo: string){
    return this.miFormulario.controls[campo].errors && 
           this.miFormulario.controls[campo].touched
  }

  //metodo Guardar()
  guardar(){

    //validar
    if (this.miFormulario.invalid){
      this.miFormulario.markAllAsTouched;
      return;
    }

    //mostrar en la consola
    console.log(this.miFormulario.value)

    //limpiar el Form si todo está OK
    this.miFormulario.reset();
  }

}
